export const OPEN = "Open"
export const CLOSED = "Closed"